import $ from 'jquery';
import * as loader from './loader';

export const init = ($target) => {
	const $eonBonusSection = $('.js-eon-bonus');

	if (!$eonBonusSection.length) {
		return;
	}

	///////////////////////////////////////////////////////////////////////////////
	/// CONSTANTS AND VARIABLES
	///////////////////////////////////////////////////////////////////////////////

	const DEFAULT_BONUS_LIST_LENGTH = 4,
		FAVOURITE_BONUS_TYPE = 'FAVORITE',
		NEWEST_BONUS_TYPE = 'NEWEST',
		API_BASE_URL = $eonBonusSection.data('api-base-url'),
		DEEP_LINK = $eonBonusSection.data('deep-link'),
		BONUS_LIST_URL = API_BASE_URL + '/bonus/list/';

	const moreInfoText = $eonBonusSection.data('more-info-link-text'),
		$allLoaders = $eonBonusSection.find('.js-loader'),
		$favouriteBonusList = $eonBonusSection.find('#eon-bonus-list-favourite'),
		$favouriteBonusListLoader = $favouriteBonusList.find('.js-loader'),
		$newestBonusList = $eonBonusSection.find('#eon-bonus-list-newest'),
		$newestBonusListLoader = $newestBonusList.find('.js-loader'),
		$allDropdowns = $eonBonusSection.find('.js-dropdown'),
		$categoryDropdown = $eonBonusSection.find('#category-dropdown'),
		allCategoriesText = $categoryDropdown.data('default-item'),
		$localityDropdown = $eonBonusSection.find('#locality-dropdown'),
		allLocalitiesText = $localityDropdown.data('default-item');

	///////////////////////////////////////////////////////////////////////////////
	/// INITIALIZATION
	///////////////////////////////////////////////////////////////////////////////

	initFilters();
	attachExpandButtonsCallbacks();

	async function initFilters() {
		loader.show($allLoaders);

		let response = null;

		// fetch initial data
		try {
			response = await fetchLists();
		} catch (err) {
			if (err.status !== '404') console.error('There seems to be an error with the API');
			console.log(err);
		}

		loader.hide($allLoaders);

		if (!response) {
			return;
		}

		// dropdowns
		await initDropdowns(response);

		// fill bonus lists
		fillBonusList($favouriteBonusList, FAVOURITE_BONUS_TYPE, response.BonusList);
		fillBonusList($newestBonusList, NEWEST_BONUS_TYPE, response.BonusList);
	}

	async function initDropdowns(response) {
		// fill dropdown values
		fillDropdown($categoryDropdown, response.CategoryList, allCategoriesText);
		fillDropdown($localityDropdown, response.LocalityList, allLocalitiesText);

		// detach and init default dropdown behaviour
		resetDropdownCallbacks();

		// select default items
		selectDefaultDropdownItem($categoryDropdown);
		selectDefaultDropdownItem($localityDropdown);

		// callbacks
		attachOnDropdownChangeCallback($allDropdowns);
	}

	async function updateResults(typeList = [FAVOURITE_BONUS_TYPE, NEWEST_BONUS_TYPE]) {
		const categoryId = getSelectedDropdownItemId($categoryDropdown),
			localityId = getSelectedDropdownItemId($localityDropdown);

		// show loader
		if (typeList.includes(FAVOURITE_BONUS_TYPE)) {
			loader.show($favouriteBonusListLoader);
		}

		if (typeList.includes(NEWEST_BONUS_TYPE)) {
			loader.show($newestBonusListLoader);
		}

		// call API
		let response = '';
		try {
			response = await fetchLists(categoryId, localityId, typeList);
		} catch (err) {
			if (err.status !== '404') console.error('There seems to be an error with the API');
			console.log(err);
		}

		// hide loader
		loader.hide($allLoaders);

		if (!response) {
			return;
		}

		// filter dropdown items
		filterVisibleDropdownItems($categoryDropdown, response.CategoryList);
		filterVisibleDropdownItems($localityDropdown, response.LocalityList);

		// fill bonus lists
		if (typeList.includes(FAVOURITE_BONUS_TYPE)) fillBonusList($favouriteBonusList, FAVOURITE_BONUS_TYPE, response.BonusList);
		if (typeList.includes(NEWEST_BONUS_TYPE)) fillBonusList($newestBonusList, NEWEST_BONUS_TYPE, response.BonusList);
	}

	function attachExpandButtonsCallbacks() {
		$favouriteBonusList.find('.js-btn-all').on('click', function () {
			$(this).hide();
			setBonusListExpanded($favouriteBonusList, true);

			updateResults([FAVOURITE_BONUS_TYPE]);
		});

		$newestBonusList.find('.js-btn-all').on('click', function () {
			$(this).hide();
			setBonusListExpanded($newestBonusList, true);

			updateResults([NEWEST_BONUS_TYPE]);
		});
	}

	function isBonusListExpanded($bonusList) {
		return !!$bonusList.data('expanded');
	}

	function setBonusListExpanded($bonusList, value) {
		$bonusList.data('expanded', value);
	}

	async function attachOnDropdownChangeCallback($dropdown) {
		$dropdown.find('.js-dropdown-input').on('change', () => updateResults());
	}

	function selectDefaultDropdownItem($dropdown) {
		const defaultItemName = $dropdown.data('default-item'),
			$dropdownToggle = $dropdown.find('.js-dropdown-toggle');

		if (!defaultItemName) {
			return;
		}

		const $defaultItemLink = $dropdown
			.find('.js-dropdown-item')
			.filter(function () {
				return $(this).find('.js-dropdown-link').text() == defaultItemName;
			})
			.first()
			.find('.js-dropdown-link');

		if (!$defaultItemLink || !$defaultItemLink.length) {
			return;
		}

		$dropdownToggle.trigger('click');
		$defaultItemLink.trigger('click');
	}

	function fillDropdown($dropdown, list, defaultText = null) {
		if (!!defaultText) {
			// add default text
			list.unshift({
				Id: 0,
				Name: defaultText,
			});
		}

		const dropdownHtml = list.map((listItem) => dropdownItemHtml(listItem.Name, listItem.Id)).join('');
		$dropdown.find('.js-dropdown-list').html(dropdownHtml);
	}

	function filterVisibleDropdownItems($dropdown, list) {
		const visibleItemsIdList = list.map((listItem) => listItem.Id);

		$dropdown.find('.js-dropdown-item').each(function () {
			const itemId = $(this).data('custom-value');

			if (itemId == 0 || visibleItemsIdList.includes(itemId)) {
				$(this).show();
			} else {
				$(this).hide();
				// console.log('hidden: ' + itemId);
			}
		});
	}

	async function fetchLists(categoryId = null, localityId = null, typeList = [FAVOURITE_BONUS_TYPE, NEWEST_BONUS_TYPE]) {
		// id lists
		const categoryIdList = !!categoryId ? [categoryId] : null,
			localityIdList = !!localityId ? [localityId] : null;

		// per page
		const anyBonusListExpanded = isBonusListExpanded($favouriteBonusList) || isBonusListExpanded($newestBonusList);
		const perPage = !!typeList && !!typeList.length && anyBonusListExpanded ? null : DEFAULT_BONUS_LIST_LENGTH;

		const reqBody = {
			Source: 'WWW',
			DeepLink: DEEP_LINK,
			Type: typeList,
			Category: categoryIdList,
			Locality: localityIdList,
			Page: 1,
			PerPage: perPage,
		};

		return $.ajax({
			type: 'POST',
			url: BONUS_LIST_URL,
			contentType: 'text/plain',
			data: JSON.stringify(reqBody),
		});
	}

	function fillBonusList($bonusList, bonusListType, responseBonusList) {
		const maxLength = isBonusListExpanded($bonusList) ? null : DEFAULT_BONUS_LIST_LENGTH;
		const bonusListHtml = buildBonusListHtml(responseBonusList, bonusListType, maxLength);
		setBonusListHtml($bonusList, bonusListHtml);
	}

	function buildBonusListHtml(responseBonusList, bonusType, maxLength = null) {
		if (!responseBonusList) {
			return '';
		}

		let bonusList = responseBonusList.filter((bonus) => bonus.Type === bonusType).map((bonus) => bonusCardHtml(bonus));

		if (maxLength) bonusList = bonusList.slice(0, maxLength);

		return bonusList.join('');
	}

	function setBonusListHtml($bonusList, bonusListHtml) {
		$bonusList.find('.js-bonus-list').html(bonusListHtml);
	}

	///////////////////////////////////////////////////////////////////////////////
	/// UTILS
	///////////////////////////////////////////////////////////////////////////////

	function resetDropdownCallbacks() {
		$allDropdowns.off();
		$allDropdowns.find('*').off();
		$target.trigger('contentload');
	}

	function getSelectedDropdownItemId($dropdown) {
		const id = parseInt($dropdown.find('.js-dropdown-input').val());
		return !isNaN(id) ? id : null;
	}

	function bonusCardHtml(bonus) {
		const arrowRight = `
			<span class="icon-svg icon-svg--arrow-right" aria-hidden="true">
				<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<use xlink:href="/img/bg/icons-svg.svg#icon-arrow-right" width="100%" height="100%"
						focusable="false"></use>
				</svg>
			</span>`;

		bonus.Picture = bonus.Picture.replace('http', 'https');

		return `
			<div class="grid__col col-3-12@xl col-4-12@lg col-6-12@sm">
				<div class="service" data-category="">
					<h3 class="service__title">${bonus.Name}</h3>
					<figure class="service__image-wrap js-objectfit">
						<picture>
							<img src="${bonus.Picture}" width="320" height="185" alt="">
						</picture>
					</figure>
					<div class="service__content">
						<p class="service__description">${bonus.DiscountDescription}</p>
						<a href="${bonus.URL}" target="_blank" rel="noopener noreferrer" class="service__link item-icon">
							<span class="item-icon__icon">
								${arrowRight}
							</span>
							<span class="item-icon__text">${moreInfoText}</span>
							<span class="service__border"></span>
						</a>
					</div>
				</div>
			</div>
			`;
	}

	const dropdownItemHtml = (name, customValue) => `
		<li class="dropdown__item js-dropdown-item" role="option" tabindex="-1"
			data-custom-value="${customValue}">
			<span class="dropdown__link js-dropdown-link">${name}</span>
		</li>
		`;
};
